module.exports = __webpack_public_path__ + "img/9.237c3cc6.jpg";